import css from 'styled-jsx/css';

export default css`
  .input {
    position: relative;
  }
  .input-form--default {
    background-color: var(--color-gp--white);
    border: 1px solid var(--color-gp--grey3);
    border-radius: 4px;
    height: 56px;
    width: 100%;
    position: relative;
  }
  .input-form--default {
    background-color: var(--color-gp--white);
    border-radius: 4px;
    height: 56px;
    width: 100%;
    position: relative;
  }
  .input__field {
    border: 0;
    outline: 0;
    font-size: 16px;
    font-family: Regular;
    color: var(--color-gp--grey6);
    padding: 24px 20px 8px 12px;
    background: transparent;
    width: 100%;
    border-radius: 4px;
  }

  .input__field::placeholder {
    color: transparent;
  }
  .input__label {
    position: absolute;
    font-size: 16px;
    font-family: Regular;
    cursor: text;
    pointer-events: none;
    white-space: nowrap;
    color: var(--color-gp--grey5);
  }
  .input__field:placeholder-shown ~ .input__label {
    top: 17px;
    left: 12px;
  }
  .input__field:not(:placeholder-shown) ~ .input__label {
    top: 9px;
    left: 12px;
    font-size: 12px;
    color: var(--color-gp--grey4);
    &--error {
      color: var(--color-gp--red);
    }
  }
  .input__field:focus ~ .input__label {
    top: 9px;
    left: 12px;
    font-size: 12px;
    color: #0066FF;
    &--error {
      color: var(--color-gp--red);
    }
  }
  .input__field:focus {
    caret-color: #0066FF;
  }
  :global(.input__error) {
    color: var(--color-gp--red);
    font-family: Regular;
    font-size: 12px;
    padding: 4px 0 0 12px;
  }
  /* remove styles from autocomplete */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-text-fill-color: var(--color-gp--grey6) !important;
    -webkit-box-shadow: 0 0 0px 1000px #ffffff inset;
  }
  /* remove styles from type number */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }

  @media screen and (min-width: 768px) {
    .input-form--default {
      height: 48px;
    }
    .input-form--no-box {
      height: 48px;
    }
    .input__field {
      padding: 20px 20px 4px 12px;
    }
    .input__field:placeholder-shown ~ .input__label {
      top: 14px;
    }
    .input__field:not(:placeholder-shown) ~ .input__label {
      top: 4px;
    }
    .input__field:focus ~ .input__label {
      top: 4px;
    }
    label,
    .input__field:focus ~ .input__label {
      top: 4px;
      left: 12px;
    }
  }
`;
